// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={175}
    height={126}
    viewBox="0 0 175 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M121.738 91L129.017 91C136.749 91 143.017 84.732 143.017 77V77C143.017 69.268 136.749 63 129.017 63L121.738 63"
      stroke="#37363F"
      strokeWidth={1.5}
      strokeDasharray="3 3"
    />
    <rect
      x={45.2473}
      y={18.75}
      width={73.4912}
      height={20.5}
      rx={3.25}
      fill="white"
      stroke="#37363F"
      strokeWidth={1.5}
    />
    <rect
      x={51.7466}
      y={24.75}
      width={8.49883}
      height={8.5}
      rx={1.25}
      fill="#75F5C4"
      stroke="#37363F"
      strokeWidth={1.5}
    />
    <rect
      x={65.4949}
      y={26.5}
      width={32.996}
      height={1}
      rx={0.5}
      fill="#37363F"
      stroke="#37363F"
    />
    <rect
      x={65.4949}
      y={30.5}
      width={18.9977}
      height={1}
      rx={0.5}
      fill="#37363F"
      stroke="#37363F"
    />
    <rect
      x={45.2473}
      y={49.75}
      width={73.4912}
      height={20.5}
      rx={3.25}
      fill="white"
      stroke="#37363F"
      strokeWidth={1.5}
    />
    <rect
      x={51.7466}
      y={55.75}
      width={8.49883}
      height={8.5}
      rx={1.25}
      fill="#75F5C4"
      stroke="#37363F"
      strokeWidth={1.5}
    />
    <rect
      x={65.4949}
      y={57.5}
      width={32.996}
      height={1}
      rx={0.5}
      fill="#37363F"
      stroke="#37363F"
    />
    <rect
      x={65.4949}
      y={61.5}
      width={18.9977}
      height={1}
      rx={0.5}
      fill="#37363F"
      stroke="#37363F"
    />
    <rect
      x={45.2473}
      y={80.75}
      width={73.4912}
      height={20.5}
      rx={3.25}
      fill="white"
      stroke="#37363F"
      strokeWidth={1.5}
    />
    <rect
      x={51.7466}
      y={86.75}
      width={8.49883}
      height={8.5}
      rx={1.25}
      fill="#75F5C4"
      stroke="#37363F"
      strokeWidth={1.5}
    />
    <rect
      x={65.4949}
      y={88.5}
      width={32.996}
      height={1}
      rx={0.5}
      fill="#37363F"
      stroke="#37363F"
    />
    <rect
      x={65.4949}
      y={92.5}
      width={18.9977}
      height={1}
      rx={0.5}
      fill="#37363F"
      stroke="#37363F"
    />
    <path
      d="M42.2787 33H35C27.268 33 21 39.268 21 47V47C21 54.732 27.268 61 35 61H42.2787"
      stroke="#37363F"
      strokeWidth={1.5}
      strokeDasharray="3 3"
    />
    <path
      d="M147.02 103.675L151.345 108L154 105.345L149.675 101.02L152.669 98.8895L141.001 95L144.89 106.669L147.02 103.675Z"
      fill="#75F5C4"
      stroke="#37363F"
      strokeMiterlimit={10}
    />
    <path
      d="M24 77.8178L24.3101 77.8287C25.5539 77.8743 26.7286 78.412 27.576 79.3237C28.4233 80.2353 28.8739 81.4461 28.8287 82.6899L28.8163 83L28.8287 82.6899C28.8511 82.074 28.9946 81.4685 29.251 80.908C29.5075 80.3476 29.8718 79.8432 30.3232 79.4236C30.7746 79.004 31.3043 78.6774 31.882 78.4626C32.4596 78.2477 33.074 78.1487 33.6899 78.1713L34 78.1837L33.6899 78.1713C33.074 78.1489 32.4685 78.0054 31.9081 77.749C31.3476 77.4925 30.8432 77.1282 30.4236 76.6768C30.004 76.2254 29.6774 75.6957 29.4626 75.118C29.2477 74.5404 29.1487 73.926 29.1714 73.3101L29.1822 73L29.1714 73.3101C29.149 73.926 29.0054 74.5315 28.749 75.092C28.4925 75.6524 28.1282 76.1568 27.6768 76.5764C27.2254 76.996 26.6957 77.3226 26.118 77.5375C25.5404 77.7523 24.926 77.8513 24.3101 77.8287L24 77.8178Z"
      fill="white"
      stroke="#37363F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M128 46.3725L128.217 46.3801C129.088 46.412 129.91 46.7884 130.503 47.4266C131.096 48.0647 131.412 48.9123 131.38 49.7829L131.371 50L131.38 49.7829C131.396 49.3518 131.496 48.9279 131.676 48.5356C131.855 48.1433 132.11 47.7902 132.426 47.4965C132.742 47.2028 133.113 46.9742 133.517 46.8238C133.922 46.6734 134.352 46.6041 134.783 46.6199L135 46.6286L134.783 46.6199C134.352 46.6043 133.928 46.5038 133.536 46.3243C133.143 46.1448 132.79 45.8897 132.497 45.5737C132.203 45.2577 131.974 44.887 131.824 44.4826C131.673 44.0783 131.604 43.6482 131.62 43.2171L131.628 43L131.62 43.2171C131.604 43.6482 131.504 44.0721 131.324 44.4644C131.145 44.8567 130.89 45.2098 130.574 45.5035C130.258 45.7972 129.887 46.0258 129.483 46.1762C129.078 46.3266 128.648 46.3959 128.217 46.3801L128 46.3725Z"
      fill="white"
      stroke="#37363F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgPlaybookEmptyStateMonocolor = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgPlaybookEmptyStateMonocolor;
